(function () {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('CampaignOwnersListController', Controller);

    Controller.$inject = ['$scope', '$modal', 'topBarService', 'surveyCampaignService', 'campaign', 'owners'];

    function Controller($scope, $modal, topBarService, surveyCampaignService, campaign, owners) {

        topBarService.setTitleAndIcon(campaign.TitleEN, 'fa fa-bullhorn', 'Owners', 'fa fa-user');

        $scope.campaign = campaign;
        $scope.owners = owners;
        $scope.view = {};

        $scope.addOwner = function () {
            // Modal to select Owner
            var modalScope = $scope.$new(true);
            modalScope.actualOwners = $scope.owners;
            modalScope.ctxSelectNewOwner = {};

            var selectNewOwnerModal = $modal({
                scope: modalScope,
                template: '/app/Main/survey/campaign/owner/selectNewOwnerModal.tpl.html',
                placement: 'center'
            });

            modalScope.hideModal = function () {
                selectNewOwnerModal.$promise.then(selectNewOwnerModal.hide);
            };

            modalScope.okModal = function () {
                modalScope.hideModal();
            };

            // Add the selected owner
            modalScope.addOwner = function (selectedEmployee) {
                surveyCampaignService
                    .addCampaignOwner($scope.campaign.SlugObject, selectedEmployee)
                    .then(function (newOwnerEmployeeObject) {
                        modalScope.ctxSelectNewOwner.selectedEmployee = newOwnerEmployeeObject;
                        if (newOwnerEmployeeObject.IsAuthorizedToManageCampaigns === false) return;

                        $scope.owners.push(newOwnerEmployeeObject);

                        modalScope.hideModal();
                    });
            }
        };
    }
})();